var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimewhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1656 113.01C46.0185 113.01 35.1217 109.704 25.8532 103.511C16.5847 97.318 9.36076 88.5156 5.09493 78.217C0.829108 67.9184 -0.287026 56.5861 1.88767 45.6531C4.06237 34.7202 9.43023 24.6776 17.3124 16.7954C25.1947 8.9132 35.2372 3.54534 46.1702 1.37064C57.1031 -0.804055 68.4354 0.312079 78.734 4.5779C89.0326 8.84373 97.835 16.0676 104.028 25.3362C110.221 34.6047 113.527 45.5015 113.527 56.6486C113.527 71.5965 107.589 85.9321 97.0188 96.5018C86.4491 107.072 72.1135 113.01 57.1656 113.01ZM57.1656 8.33925C47.6109 8.33925 38.2708 11.1725 30.3264 16.4808C22.382 21.7891 16.19 29.334 12.5336 38.1614C8.87718 46.9888 7.9205 56.7022 9.78452 66.0733C11.6486 75.4444 16.2496 84.0523 23.0058 90.8085C29.7619 97.5647 38.3699 102.166 47.7409 104.03C57.112 105.894 66.8254 104.937 75.6528 101.281C84.4802 97.6242 92.0251 91.4323 97.3334 83.4879C102.642 75.5434 105.475 66.2033 105.475 56.6486C105.475 43.8362 100.385 31.5485 91.3255 22.4887C82.2657 13.429 69.9781 8.33925 57.1656 8.33925V8.33925Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6457 80.8042L53.1416 58.3001V20.4175H61.1932V54.9587L81.3221 75.1278L75.6457 80.8042Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimewhite);
export default __webpack_public_path__ + "static/media/timewhite.19c4726b1cce09a87f0c4b4116855819.svg";
export { ForwardRef as ReactComponent };